import { createGqlQuery } from '../fetcher';
import { Labels } from '../queries/labels.query';
import type * as Types from '../types';

export const useLabelsQuery = createGqlQuery<Types.LabelsQueryVariables, Types.LabelsQuery>(
  (vars) => ['organization', vars.organizationId, 'labels', vars.type],
  Labels,
);
